<script setup lang="ts">
import TooltipIcon from './TooltipIcon.vue';

const props = defineProps<{
  label: string;
  modelValue: boolean;
  tooltip?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();
</script>

<template>
  <label class="toggle-row">
    <div class="label">
      {{ label }}
      <TooltipIcon v-if="tooltip" :text="tooltip" />
    </div>
    <input type="checkbox" :checked="modelValue" @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)" />
  </label>
</template>

<style scoped>
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.5rem 0.6rem;
}

input[type='checkbox'] {
  width: 18px;
  height: 18px;
}
</style>
